import { FileDeliveryOptions, Integrations } from 'store/college'

export interface CampusESPConfiguration {
  id: string
  type: 'campusESP'
  enabled: boolean
  username: string
  publicKey?: string
}
export interface State extends Integrations, FileDeliveryOptions {
  hasError: boolean
  isLoading: boolean
  slateTestSuccessful?: boolean
  sftpTestSuccessful?: boolean
  keySuccessful?: boolean
  isDocsDeliveryEnabled?: boolean
  campusESPConfiguration?: CampusESPConfiguration
  campusESPTestSuccessful?: boolean
}

export type Action =
  | {
      type: 'load-integrations'
      integrations?: Integrations
      fileDeliveryOptions?: FileDeliveryOptions
    }
  | { type: 'set-error'; hasError: boolean }
  | { type: 'update-integrations'; integrations: Integrations; keySuccessful?: boolean }
  | { type: 'update-file-delivery-options'; fileDeliveryOptions: FileDeliveryOptions }
  | { type: 'set-slate-test-connection'; testSuccessful?: boolean }
  | { type: 'set-sftp-test-connection'; testSuccessful?: boolean }
  | { type: 'update-batch-transcript-setting'; concatenateBatchTranscripts: boolean }
  | { type: 'update-configured-delivery-method'; deliveryMethod: 'sftp' | 'slate' }
  | { type: 'update-force-new-easy-slate-index-fields'; forceNewEasySlateIndexFields: boolean }
  | { type: 'load-campus-esp-configuration'; campusESPConfiguration?: CampusESPConfiguration }
  | { type: 'set-campus-esp-configuration'; campusESPConfiguration?: CampusESPConfiguration }
  | { type: 'test-sftp-configuration'; testSuccessful?: boolean }

export const initialState: State = {
  hasError: false,
  isLoading: true,
}

export default function integrationsReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'load-integrations':
      return {
        ...state,
        ...action.integrations,
        ...action.fileDeliveryOptions,
        isDocsDeliveryEnabled:
          action.integrations?.Slate?.Status === 'Live' || action.integrations?.SFTP?.Status === 'Live',
        isLoading: false,
        hasError: false,
      }
    case 'set-error':
      return {
        ...state,
        hasError: action.hasError,
        isLoading: false,
      }
    case 'update-integrations':
      return {
        ...state,
        ...action.integrations,
        isDocsDeliveryEnabled:
          action.integrations?.Slate?.Status === 'Live' || action.integrations?.SFTP?.Status === 'Live',
        hasError: false,
        keySuccessful: action.keySuccessful,
        // Reset error states on property updates
        slateTestSuccessful: undefined,
        sftpTestSuccessful: undefined,
      }
    case 'update-file-delivery-options':
      return {
        ...state,
        ...action.fileDeliveryOptions,
      }
    case 'set-slate-test-connection':
      return {
        ...state,
        slateTestSuccessful: action.testSuccessful,
      }
    case 'set-sftp-test-connection':
      return {
        ...state,
        sftpTestSuccessful: action.testSuccessful,
      }
    case 'update-batch-transcript-setting':
      return {
        ...state,
        ConcatenateBatchTranscripts: action.concatenateBatchTranscripts,
      }
    case 'update-configured-delivery-method':
      return {
        ...state,
        ConfiguredDeliveryMethod: action.deliveryMethod,
      }
    case 'update-force-new-easy-slate-index-fields':
      return {
        ...state,
        ForceNewEasySlateIndexFields: action.forceNewEasySlateIndexFields,
      }
    case 'load-campus-esp-configuration':
    case 'set-campus-esp-configuration':
      return {
        ...state,
        campusESPConfiguration: action.campusESPConfiguration,
        campusESPTestSuccessful: undefined,
      }
    case 'test-sftp-configuration':
      return {
        ...state,
        campusESPTestSuccessful: action.testSuccessful,
      }
    default:
      return state
  }
}
